<script setup>
import { useI18n } from 'vue-i18n';
import BaseNode from './BaseNode.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>

<template>
  <BaseNode
    :node-id="props.id"
    :selected="selected"
    icon="i-lucide-play"
    :type-label="t('SOPS.NODES.START')"
    :node-label="data.label"
    accent-class="bg-n-teal-9/15 text-n-teal-9"
    :has-target="false"
  />
</template>
